import React, { useState } from 'react';
import ErrorAlert, {
  ErrorAlertProps,
} from '../../common/ui/ErrorAlert/ErrorAlert';

type PopupError = ErrorAlertProps & { id: number };
type ShowError = { showError: (text: string) => void };

function* createIdGenerator() {
  for (let i = 0; i < Infinity; i += 1) yield i;
}

const idGenerator = createIdGenerator();

function withPopupErrors<P extends ShowError>(
  Component: React.ComponentType<P>,
) {
  return (props: Omit<P, 'showError'>) => {
    const [errors, setErrors] = useState<PopupError[]>([]);

    const showError = (text: string) => {
      const id = (idGenerator.next().value ?? 0) as number;
      setErrors((prevErrors) => [...prevErrors, { id, text, hidden: false }]);
    };

    const deleteError = (id: number) => {
      setErrors((prev) => {
        const newErrors: PopupError[] = [];

        prev.forEach((error) => {
          if (error.id === id) return;
          newErrors.push(error);
        });

        return newErrors;
      });
    };

    const hideError = (id: number) => {
      setErrors((prev) =>
        prev.map((error) => {
          if (error.id === id) return { ...error, hidden: true };
          return error;
        }),
      );

      setTimeout(() => deleteError(id), 100);
    };

    return (
      <>
        <div
          style={{
            position: 'absolute',
            left: '50%',
            marginLeft: '-300px',
            bottom: '0',
            width: '600px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            justifyContent: 'flex-end',
          }}
        >
          {errors.map(({ id, text, hidden }) => (
            <ErrorAlert
              key={id}
              text={text}
              hidden={hidden}
              close={() => hideError(id)}
            />
          ))}
        </div>

        {/* @ts-ignore */}
        <Component showError={showError} {...props} />
      </>
    );
  };
}

export default withPopupErrors;
